import { render, staticRenderFns } from "./DeductTable.vue?vue&type=template&id=5120f1f8&scoped=true&"
import script from "./DeductTable.vue?vue&type=script&lang=js&"
export * from "./DeductTable.vue?vue&type=script&lang=js&"
import style0 from "./DeductTable.vue?vue&type=style&index=0&id=5120f1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120f1f8",
  null
  
)

export default component.exports